import { createReducer } from "sc/helpers/reducer";
import {
  REGION_PAGE_LOADED,
  REGION_EMAIL_DELETE_REQUEST,
  REGION_EMAIL_DELETED,
  REGION_EMAIL_ADD_REQUEST,
  REGION_EMAIL_ADDED,
  REGION_UPDATE_REQUEST,
  REGION_UPDATED,
  REGION_ADD_REQUEST,
  REGION_ADD_ERROR,
  REGION_UPDATE_ERROR,
  REGION_EMAIL_ADD_ERROR,
  REGION_EMAIL_DELETE_ERROR,
} from "../actions/regions";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [REGION_PAGE_LOADED]: (state, action) => {
    const { emails, ...generalData } = action.payload.region;
    const emailsWithState = emails.map(email => ({
      value: email,
      deleteInProgress: false,
    }));
    return Object.assign({}, generalData, {
      emails: emailsWithState,
      emailAddInProgress: false,
      generalDataSaveInProgress: false,
    });
  },
  [REGION_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [REGION_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [REGION_UPDATE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [REGION_UPDATE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [REGION_UPDATED]: (state, action) =>
    Object.assign({}, state, { generalDataSaveInProgress: false }),
  [REGION_EMAIL_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      emailAddInProgress: true,
      emailAddError: "",
    }),
  [REGION_EMAIL_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      emailAddInProgress: false,
      emailAddError: action.payload.message,
    }),
  [REGION_EMAIL_ADDED]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = [
      ...emails,
      { value: action.payload.email, deleteInProgress: false },
    ];
    return Object.assign({}, generalData, {
      emails: updatedList,
      emailAddInProgress: false,
    });
  },
  [REGION_EMAIL_DELETE_REQUEST]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.map(email => ({
      value: email.value,
      deleteInProgress:
        email.value === action.payload.email ? true : email.deleteInProgress,
    }));
    return Object.assign({}, generalData, { emails: updatedList });
  },
  [REGION_EMAIL_DELETE_ERROR]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.map(email => ({
      value: email.value,
      deleteInProgress:
        email.value === action.payload.email ? false : email.deleteInProgress,
    }));
    return Object.assign({}, generalData, { emails: updatedList });
  },
  [REGION_EMAIL_DELETED]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.filter(
      email => email.value !== action.payload.email,
    );
    return Object.assign({}, generalData, { emails: updatedList });
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/region-reducer.js